<div class="filter-box">
  <div class="filter-top">
    <span class="filter-label">
      {{ filter.label | translate }}
    </span>
    <button (click)="onClose()">X</button>
  </div>
  @if (!isSlider) {
    <div class="filter-options">
      @for (option of filterOptions; track $index) {
        <div
          class="filter-option"
          [class.active]="
            filterHelpers.isOptionSelected(option, selectedOptions)
          ">
          @if (!filter.isRadio) {
            <input
              type="checkbox"
              [id]="filterHelpers.generateFilterOptionId(option)"
              [checked]="
                filterHelpers.isOptionSelected(option, selectedOptions)
              "
              (change)="onCheckboxChange($event, option)"
              [disabled]="
                !filterHelpers.isOptionEnabled(
                  option,
                  selectedOptions,
                  filter,
                  filterOptions
                )
              " />
          } @else {
            <input
              type="radio"
              [id]="filterHelpers.generateFilterOptionId(option)"
              [checked]="
                filterHelpers.isOptionSelected(option, selectedOptions)
              "
              (change)="onRadioChange(option)" />
          }
          <label [for]="filterHelpers.generateFilterOptionId(option)">{{
            option.label
              | translate: filterHelpers.getTranslationParameters(option, unit)
          }}</label>
          @if (
            hasCustomSliderOption &&
            isCustomOption(option) &&
            filterHelpers.isOptionSelected(option, selectedOptions)
          ) {
            <div class="filter-slider">
              <app-filter-slider
                [unit]="unit"
                [filter]="filter"
                [fullRangeOption]="option"
                [(selectedOptions)]="customSelectedOptions"
                (selectedOptionsChange)="onSliderChange()" />
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="slider" />
  }
  <div class="box-buttons">
    <button class="clear-btn" (click)="onClearFilter()">
      {{ 'browse.filterSort.clearBtnTitle' | translate }}
    </button>
    <button
      [disabled]="!isFilterEnabled"
      class="filter-btn"
      (click)="onApplyFilter()">
      {{ 'browse.filterSort.filterBtnTitle' | translate }}
    </button>
  </div>
</div>

<ng-template #slider>
  <div class="filter-slider">
    <app-filter-slider
      [unit]="unit"
      [filter]="filter"
      [fullRangeOption]="filterOptions[0]"
      [(selectedOptions)]="selectedOptions"
      (selectedOptionsChange)="onSliderChange()" />
  </div>
</ng-template>
